import { LOCATION_CHANGED, LocationChangedAction } from 'redux-little-router';
import { ofType, StateObservable } from 'redux-observable';
import { EMPTY, Observable, OperatorFunction } from 'rxjs';
import { audit, filter } from 'rxjs/operators';

import { Action } from '../actions';
import { UPDATE_COMMON_DATA } from '../actions/common';
import { RoutesPath } from '../routes/index';
import { State } from '../typings/state';

export const awaitCommonData = (
    action$: Observable<Action>,
    store$: StateObservable<State>
): OperatorFunction<Action, Action> => {
    return audit(() => {
        if (store$.value.commonData.dataFetched) {
            return EMPTY;
        }
        return action$.pipe(ofType(UPDATE_COMMON_DATA));
    });
};

export const ofRoute = (
    ...routes: RoutesPath[]
): OperatorFunction<Action, Action> => {
    return filter((action: Action) => {
        if (action.type !== LOCATION_CHANGED) {
            return false;
        }
        return routes.includes(action.payload.route);
    });
};

export const notOfRoute = (
    ...routes: RoutesPath[]
): OperatorFunction<Action, Action> => {
    return filter((action: Action) => {
        if (action.type !== LOCATION_CHANGED) {
            return false;
        }
        return !routes.includes(action.payload.route);
    });
};

export const ofNewVisit = (
    store$: StateObservable<State>
): OperatorFunction<LocationChangedAction, LocationChangedAction> => {
    return filter((action: LocationChangedAction) => {
        const { route } = action.payload;
        const { previous } = store$.value.router;
        return route !== (previous && previous.route);
    });
};
